import { render, staticRenderFns } from "./DashboardKey.vue?vue&type=template&id=012a011b&scoped=true&"
import script from "./DashboardKey.vue?vue&type=script&lang=js&"
export * from "./DashboardKey.vue?vue&type=script&lang=js&"
import style0 from "./DashboardKey.vue?vue&type=style&index=0&id=012a011b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a011b",
  null
  
)

export default component.exports